"use client";

import Image from "next/image";

// Depoimentos para a linha superior (animação para direita)
const topRowTestimonials = [
  { name: "Ana Silva", role: "Desenvolvedora Front End", testimonial: "Consegui 3 entrevistas na primeira semana!", photo: "https://i.pravatar.cc/150?img=32" },
  { name: "Carlos Santos", role: "Product Manager", testimonial: "Economizei horas aplicando automaticamente.", photo: "https://i.pravatar.cc/150?img=18" },
  { name: "Mariana Costa", role: "UX Designer", testimonial: "A plataforma mudou minha busca por emprego!", photo: "https://i.pravatar.cc/150?img=49" },
  { name: "João Oliveira", role: "Data Scientist", testimonial: "Finalmente encontrei a vaga dos meus sonhos!", photo: "https://i.pravatar.cc/150?img=59" },
  { name: "Fernanda Lima", role: "Marketing Digital", testimonial: "Incrível como funciona perfeitamente!", photo: "https://i.pravatar.cc/150?img=44" },
  { name: "Ricardo Alves", role: "DevOps Engineer", testimonial: "Recomendo para todos os profissionais!", photo: "/testimonials/32.jpg" },
  { name: "Juliana Rocha", role: "Business Analyst", testimonial: "Aumentou minhas chances significativamente!", photo: "/testimonials/45.jpg" },
  { name: "Pedro Martins", role: "Backend Developer", testimonial: "Melhor investimento que fiz na carreira!", photo: "https://i.pravatar.cc/150?img=8" },
  { name: "Larissa Souza", role: "Frontend Developer", testimonial: "Simplesmente revolucionário!", photo: "/testimonials/54.jpg" },
  { name: "Bruno Ferreira", role: "Tech Lead", testimonial: "Superou todas as minhas expectativas!", photo: "/testimonials/33.jpg" },
];

// Depoimentos para a linha inferior (animação para esquerda)
const bottomRowTestimonials = [
  { name: "Patricia Gomes", role: "Scrum Master", testimonial: "Processo totalmente automatizado e eficiente!", photo: "/testimonials/2.jpg" },
  { name: "Thiago Ribeiro", role: "Mobile Developer", testimonial: "Economizei tanto tempo que nem acredito!", photo: "/testimonials/1.jpg" },
  { name: "Camila Torres", role: "QA Engineer", testimonial: "A melhor ferramenta que já usei!", photo: "/testimonials/3.jpg" },
  { name: "Gabriel Nunes", role: "Cloud Architect", testimonial: "Resultados incríveis desde o primeiro dia!", photo: "/testimonials/2.jpg" },
  { name: "Isabela Mendes", role: "Content Manager", testimonial: "Transformou minha busca por emprego!", photo: "/testimonials/4.jpg" },
  { name: "Lucas Pereira", role: "Security Engineer", testimonial: "Recomendo sem hesitação!", photo: "/testimonials/4.jpg" },
  { name: "Beatriz Araújo", role: "Product Owner", testimonial: "Superou todas as expectativas!", photo: "/testimonials/8.jpg" },
  { name: "Rafael Dias", role: "Full Stack Developer", testimonial: "A plataforma é simplesmente perfeita!", photo: "/testimonials/14.jpg" },
  { name: "Amanda Freitas", role: "UI Designer", testimonial: "Consegui a vaga que sempre sonhei!", photo: "/testimonials/11.jpg" },
  { name: "Diego Campos", role: "System Administrator", testimonial: "Melhor decisão profissional que tomei!", photo: "/testimonials/16.jpg" },
];

export function TestimonialsPanel() {
  return (
    <div className="hidden lg:flex w-full lg:w-3/5 relative h-screen overflow-hidden order-first lg:order-last">
      {/* Background Image */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-400 to-blue-600">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-100"
          style={{
            backgroundImage: "url('/bg-auth.png')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-400/0 to-blue-600/0"></div>
      </div>
      
      {/* Testimonials Section */}
      <div className="relative w-full h-full flex flex-col items-center pt-60 pb-10 overflow-x-hidden overflow-y-hidden" style={{ marginTop: '15vh' }}>
        {/* Top Row - Moving Right */}
        <div className="w-full overflow-x-hidden overflow-y-visible mb-4 py-4">
          <div className="flex animate-scroll-right">
            {[...topRowTestimonials, ...topRowTestimonials].map((testimonial, idx) => (
              <div key={idx} className="flex-shrink-0 mx-3 w-80 bg-white/60 backdrop-blur-sm rounded-lg shadow-lg p-4 transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:z-[100] relative cursor-pointer" style={{ transformOrigin: 'center' }}>
                <div className="flex items-center mb-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-3 flex-shrink-0">
                    <Image
                      src={testimonial.photo}
                      alt={testimonial.name}
                      width={48}
                      height={48}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
                    <p className="text-xs text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-sm text-gray-700 italic">"{testimonial.testimonial}"</p>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Row - Moving Left */}
        <div className="w-full overflow-x-hidden overflow-y-visible py-4">
          <div className="flex animate-scroll-left">
            {[...bottomRowTestimonials, ...bottomRowTestimonials].map((testimonial, idx) => (
              <div key={idx} className="flex-shrink-0 mx-3 w-80 bg-white/60 backdrop-blur-sm rounded-lg shadow-lg p-4 transition-all duration-300 hover:scale-110 hover:shadow-2xl hover:z-[100] relative cursor-pointer" style={{ transformOrigin: 'center' }}>
                <div className="flex items-center mb-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-3 flex-shrink-0">
                    <Image
                      src={testimonial.photo}
                      alt={testimonial.name}
                      width={48}
                      height={48}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
                    <p className="text-xs text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-sm text-gray-700 italic">"{testimonial.testimonial}"</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
